import { createAction, props } from '@ngrx/store';
import { TokenData } from 'src/app/model/api/token-data';
import { RowDataDb, SectionData, SectionDataDb, SubSectionData, SubSectionDataDb } from 'src/app/model/help';


export const getHelp = createAction('GET_HELP', props<{
    appid: string;
}>());
export const getHelpSuccess = createAction('GET_HELP_SUCCESS', props<{
    sectionList: SectionData[];
}>());
export const getHelpFailed = createAction('GET_HELP_FAILED', props<{ errorMessage: string }>());

export const getHelpAll = createAction('GET_HELP_ALL');
export const getHelpAllSuccess = createAction('GET_HELP_ALL_SUCCESS', props<{
    sectionList: SectionData[];
}>());
export const getHelpAllFailed = createAction('GET_HELP_ALL_FAILED', props<{ errorMessage: string }>());


export const getHelpGuest = createAction('GET_HELP_GUEST', props<{
    appid: string;
}>());
export const getHelpGuestSuccess = createAction('GET_HELP_GUEST_SUCCESS', props<{
    sectionList: SectionData[];
}>());
export const getHelpGuestFailed = createAction('GET_HELP_GUEST_FAILED', props<{ errorMessage: string }>());

export const getHelpGuestSearch = createAction('GET_HELP_SEARCH_GUEST', props<{
    filter: string;
    appid: string;
}>());
export const getHelpGuestSearchSuccess = createAction('GET_HELP_GUEST_SEARCH_SUCCESS', props<{
    subSectionList: SubSectionData[];
}>());
export const getHelpGuestSearchFailed = createAction('GET_HELP_GUEST_SEARCH_FAILED', props<{ errorMessage: string }>());


export const getHelpSearch = createAction('GET_HELP_SEARCH', props<{
    filter: string;
    appid: string;
}>());
export const getHelpSearchSuccess = createAction('GET_HELP_SEARCH_SUCCESS', props<{
    subSectionList: SubSectionData[];
}>());
export const getHelpSearchFailed = createAction('GET_HELP_SEARCH_FAILED', props<{ errorMessage: string }>());


//Gestione Sezioni
export const getHelpSectionAll = createAction('GET_HELP_SECTION_ALL');
export const getHelpSectionAllSuccess = createAction('GET_HELP_SECTION_ALL_SUCCESS',props<{ sectionList: SectionDataDb[]}>());
export const getHelpSectionAllFailed = createAction('GET_HELP_SECTION_ALL_FAILED', props<{ errorMessage: string }>());

export const getHelpSections = createAction('GET_HELP_SECTIONS');
export const getHelpSectionsSuccess = createAction('GET_HELP_SECTIONS_SUCCESS', props<{ sections: SectionDataDb[]}>());
export const getHelpSectionsFailed = createAction('GET_HELP_SECTIONS_FAILED', props<{ errorMessage: string }>());

export const getHelpSection = createAction('GET_HELP_SECTION', props<{ sectionId: number}>());
export const getHelpSectionSuccess = createAction('GET_HELP_SECTION_SUCCESS', props<{ section: SectionDataDb}>());
export const getHelpSectionFailed = createAction('GET_HELP_SECTION_FAILED', props<{ errorMessage: string }>());

export const addHelpSection = createAction('ADD_HELP_SECTION', props<{ section: SectionDataDb }>());
export const addHelpSectionSuccess = createAction('ADD_HELP_SECTION_SUCCESS', props<{ message: string }>());
export const addHelpSectionFailed = createAction('ADD_HELP_SECTION_FAILED', props<{ errorMessage: string }>());

export const editHelpSection = createAction('EDIT_HELP_SECTION', props<{ section: SectionDataDb }>());
export const editHelpSectionSuccess = createAction('EDIT_HELP_SECTION_SUCCESS', props<{ message: string }>());
export const editHelpSectionFailed = createAction('EDIT_HELP_SECTION_FAILED', props<{ errorMessage: string }>());

export const deleteHelpSection = createAction('DELETE_HELP_SECTION', props<{ sectionId: number }>());
export const deleteHelpSectionSuccess = createAction('DELETE_HELP_SECTION_SUCCESS', props<{ message: string }>());
export const deleteHelpSectionFailed = createAction('DELETE_HELP_SECTION_FAILED', props<{ errorMessage: string }>());


export const resetSectionForm = createAction('RESET_HELP_SECTION_FORM');

export const getHelpSubSections = createAction('GET_HELP_SUB_SECTIONS', props<{ sectionId: number}>());
export const getHelpSubSectionsSuccess = createAction('GET_HELP_SUB_SECTIONS_SUCCESS', props<{ subsections: SubSectionDataDb[]}>());
export const getHelpSubSectionsFailed = createAction('GET_HELP_SUB_SECTIONS_FAILED', props<{ errorMessage: string }>());

export const getHelpSubSection = createAction('GET_HELP_SUB_SECTION', props<{ subsectionId: number}>());
export const getHelpSubSectionSuccess = createAction('GET_HELP_SUB_SECTION_SUCCESS', props<{ subsection: SubSectionDataDb}>());
export const getHelpSubSectionFailed = createAction('GET_HELP_SUB_SECTION_FAILED', props<{ errorMessage: string }>());

export const addHelpSubSection = createAction('ADD_HELP_SUB_SECTION', props<{ subsection: SubSectionDataDb }>());
export const addHelpSubSectionSuccess = createAction('ADD_HELP_SUB_SECTION_SUCCESS', props<{ message: string }>());
export const addHelpSubSectionFailed = createAction('ADD_HELP_SUB_SECTION_FAILED', props<{ errorMessage: string }>());

export const editHelpSubSection = createAction('EDIT_HELP_SUB_SECTION', props<{ subsection: SubSectionDataDb }>());
export const editHelpSubSectionSuccess = createAction('EDIT_HELP_SUB_SECTION_SUCCESS', props<{ message: string }>());
export const editHelpSubSectionFailed = createAction('EDIT_HELP_SUB_SECTION_FAILED', props<{ errorMessage: string }>());

export const deleteHelpSubSection = createAction('DELETE_HELP_SUB_SECTION', props<{ subsectionId: number }>());
export const deleteHelpSubSectionSuccess = createAction('DELETE_HELP_SUB_SECTION_SUCCESS', props<{ message: string }>());
export const deleteHelpSubSectionFailed = createAction('DELETE_HELP_SUB_SECTION_FAILED', props<{ errorMessage: string }>());


export const resetSubSectionForm = createAction('RESET_HELP_SUB_SECTION_FORM');

export const getHelpRows = createAction('GET_HELP_ROWS', props<{ subsectionId: number}>());
export const getHelpRowsSuccess = createAction('GET_HELP_ROWS_SUCCESS', props<{ rows: RowDataDb[]}>());
export const getHelpRowsFailed = createAction('GET_HELP_ROWS_FAILED', props<{ errorMessage: string }>());

export const getHelpRow = createAction('GET_HELP_ROW', props<{ rowId: number}>());
export const getHelpRowSuccess = createAction('GET_HELP_ROW_SUCCESS', props<{ row: RowDataDb}>());
export const getHelpRowFailed = createAction('GET_HELP_ROW_FAILED', props<{ errorMessage: string }>());

export const addHelpRow = createAction('ADD_HELP_ROW', props<{ row: RowDataDb }>());
export const addHelpRowSuccess = createAction('ADD_HELP_ROW_SUCCESS', props<{ message: string }>());
export const addHelpRowFailed = createAction('ADD_HELP_ROW_FAILED', props<{ errorMessage: string }>());

export const editHelpRow = createAction('EDIT_HELP_ROW', props<{ row: RowDataDb }>());
export const editHelpRowSuccess = createAction('EDIT_HELP_ROW_SUCCESS', props<{ message: string }>());
export const editHelpRowFailed = createAction('EDIT_HELP_ROW_FAILED', props<{ errorMessage: string }>());

export const deleteHelpRow = createAction('DELETE_HELP_ROW', props<{ rowId: number }>());
export const deleteHelpRowSuccess = createAction('DELETE_HELP_ROW_SUCCESS', props<{ message: string }>());
export const deleteHelpRowFailed = createAction('DELETE_HELP_ROW_FAILED', props<{ errorMessage: string }>());


export const resetRowForm = createAction('RESET_HELP_ROW_FORM');

